import type { Theme } from '@mui/material/styles';
import styled from 'styled-components';

import { body } from '@constants/fonts';

function resolveColor(props: { disabled?: boolean | undefined; theme: Theme }) {
  if (props.disabled) {
    return props.theme.palette.grey['300'];
  }
  return props.theme.palette.primary.main;
}

export const NumberWrapper = styled.div`
  margin: 0 auto;
  white-space: nowrap;
  max-width: 300px;
`;

export const NumberPickerButton = styled.button<{ stepType: 'minus' | 'plus' }>`
  height: 47px;
  width: 47px;
  float: ${(props) => (props.stepType === 'plus' ? 'none' : 'left')};
  border-radius: ${(props) =>
    props.stepType === 'minus' ? '29px 0px 0px 29px' : '0px 29px 29px 0px'};
  background-color: ${(props) => resolveColor(props)};
  box-shadow: ${(props) =>
    props.disabled
      ? 'none'
      : ` 0 0 12px 0 ${props.theme.palette.grey['900']}24`};
  color: ${(props) =>
    props.disabled
      ? props.theme.palette.common.white
      : props.theme.palette.primary.contrastText};
  font-family: ${body};
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  border: 0px;
  padding: 0;
  margin: 5px 0;
  -webkit-transition: all 0.1s linear;
  transition: all 0.1s linear;

  &:hover,
  &:focus {
    cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')};
    background-color: ${(props) =>
      props.disabled ? resolveColor(props) : props.theme.palette.primary.light};
  }

  &:active {
    background-color: ${({ theme }) => theme.palette.primary.dark};
  }
`;

export const NumberInput = styled.input`
  box-sizing: border-box;
  height: 47px;
  width: calc(100% - 47px);
  float: left;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  line-height: 22px;
  padding: 10px;
  margin: 5px 0;
  text-align: center;
  opacity: 1 !important;
`;

export const LabelStyle = styled.label`
  height: 22px;
  width: 100%;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 16px;
  line-height: 22px;
  margin: 0;
  box-sizing: border-box;
  display: block;
  text-align: center;
`;
